export default __webpack_public_path__ + "static/media/element_30.902e3390.webp";